import { Position } from '@/tmp/Target';
import { LatLng, LatLngExpression } from 'leaflet';
import { Pane, Polyline } from 'react-leaflet';

const TRACKED_PATH_PANE = 'trackedPathPane';

function getPolyline(p: Position[]): LatLng[] {
  return p.map((pp) => new LatLng(pp.latitude, pp.longitude));
}

function colorSegmentScale(startColor: number, stopColor: number, scale: number): string {
  const distance = stopColor - startColor;
  const value = Math.floor(startColor + distance * scale);
  return (value < 0x10 ? '0' : '') + value.toString(16);
}

export function TrackedPathPolyline({ targetId, positions }: { targetId: number; positions: Position[] }) {
  if (!positions || !positions.length) return null;

  const firstTimeMicros = positions[0].timeMicros;
  const lastTimeMicros = positions[positions.length - 1].timeMicros;

  const pathLengthInTimeMicros = lastTimeMicros - firstTimeMicros;

  let segments = positions.map((pos, index) => {
    if (index === 0) return null;

    const prev = new LatLng(positions[index - 1].latitude, positions[index - 1].longitude);
    const curr = new LatLng(pos.latitude, pos.longitude);

    if (prev.lat === curr.lat && prev.lng === curr.lng) return null;

    const segment: LatLngExpression[] = [prev, curr];
    const inPathScale = (pos.timeMicros - firstTimeMicros) / pathLengthInTimeMicros;

    const colorR = colorSegmentScale(0x00, 0x00, inPathScale);
    const colorG = colorSegmentScale(0x37, 0xb4, inPathScale);
    const colorB = colorSegmentScale(0x5c, 0xff, inPathScale);

    const polylineKey = `trackedPath-${targetId}-${pos.longitude}-${pos.latitude}-${pos.timeMicros}`;

    return (
      <Polyline
        key={polylineKey}
        pane={TRACKED_PATH_PANE}
        positions={segment}
        stroke={true}
        weight={6 * inPathScale + 1}
        pathOptions={{ lineCap: 'round', lineJoin: 'round' }}
        color={`#${colorR}${colorG}${colorB}`}
      />
    );
  });

  segments = segments.filter((s) => s !== null);

  return (
    <Pane name={TRACKED_PATH_PANE} style={{ pointerEvents: 'none' }}>
      <Polyline
        pane={TRACKED_PATH_PANE}
        positions={getPolyline(positions)}
        stroke={true}
        weight={10}
        pathOptions={{ lineCap: 'round', lineJoin: 'round' }}
        color={'#00375c'}
        opacity={0.4}
      />
      {segments}
    </Pane>
  );
}
